import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PictureComponent } from '@freelancer/ui/picture';
import {
  PictureBackgroundImageStyles,
  PictureBgImageObjectFit,
} from '@freelancer/ui/picture';

@Component({
  standalone: true,
  selector: 'fl-banner-upsell-background-image',
  imports: [PictureComponent],
  template: `
    <fl-picture
      [src]="src"
      [srcTablet]="srcTablet"
      [srcDesktop]="srcDesktop"
      [srcLargeDesktop]="srcLargeDesktop"
      [alt]="alt"
      [isBackgroundImage]="true"
      [backgroundStyles]="backgroundStyles"
      (imageLoaded)="handleImageLoaded()"
    >
    </fl-picture>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerUpsellBackgroundImageComponent {
  @Input() alt: string;
  @Input() src: string;
  @Input() srcTablet?: string;
  @Input() srcDesktop?: string;
  @Input() srcLargeDesktop?: string;
  @Input() backgroundStyles?: PictureBackgroundImageStyles = {
    position: 'right center',
    objectFit: PictureBgImageObjectFit.COVER,
  };

  @Output() imageLoaded = new EventEmitter<void>();

  handleImageLoaded(): void {
    this.imageLoaded.emit();
  }
}
